{
  "pageTitle": "API, SWIFT and SFTP",
  "tabs": {
    "pendingVerificationChecks": "Pending verification checks",
    "inProgress": "In Progress",
    "complete": "Complete",
    "rejected": "Rejected & Unsuccessful"
  },
  "pendingChecksAlert": {
    "title": "Some channel payments can’t be sent yet",
    "subtitlePrefix": "One or more channel payments are awaiting beneficiary verification.",
    "subtitleSuffix": {
      "static": "View pending verification checks to review them.",
      "link": "Click here to <0>view pending beneficiary checks.</0>"
    }
  },
  "table": {
    "searchPlaceholder": "Search",
    "headers": {
      "createdAndSource": "Created & Source",
      "beneficiary": "Beneficiary",
      "fundFrom": "Fund from",
      "fixedAmount": "Fixed amount",
      "status": "Status",
      "action": "Action"
    },
    "tabs": {
      "pending-verification-checks": {
        "emptyState": {
          "title": "You don’t have any pending verification checks",
          "description": "Any channel payments which require a beneficiary verification check will be shown here."
        }
      },
      "in-progress": {
        "emptyState": {
          "title": "You don’t have any channel payments in progress.",
          "description": "Any channel payments still being processed will appear here."
        }
      },
      "complete": {
        "emptyState": {
          "title": "You don’t have any completed channel payments.",
          "description": "Once a channel payment is processed successfully, you’ll find it here."
        }
      },
      "rejected": {
        "emptyState": {
          "title": "You don’t have any rejected or cancelled channel payments.",
          "description": "Any channel payments that are rejected or cancelled will appear here."
        }
      }
    },
    "verificationRequiredStatus": "Verification required",
    "action": {
      "review": {
        "buttonText": "Review",
        "modal": {
          "button": {
            "sendPaymentAnyway": "Send payment anyway",
            "rejectPayment": "Reject payment"
          }
        },
        "approved": {
          "success": {
            "title": "The payment has been successfully sent",
            "description": "You can view it in the In Progress tab."
          },
          "permissionError": {
            "title": "Unable to send payment",
            "description": "You do not have permission to action the VoP check for payments from this entity."
          },
          "genericError": {
            "title": "Unable to send payment",
            "description": "Please try again. If the issue continues, please contact Client Services."
          }
        },
        "rejected": {
          "success": {
            "title": "The payment has been rejected",
            "description": "You can view it in the Rejected & Unsuccessful tab."
          },
          "permissionError": {
            "title": "Unable to reject payment",
            "description": "You do not have permission to action the VoP check for payments from this entity."
          },
          "genericError": {
            "title": "Unable to reject payment",
            "description": "Please try again. If the issue continues, please contact Client Services."
          }
        }
      },
      "view": {
        "actionTooltip": "Click to view payment"
      }
    },
    "errors": {
      "dataError": {
        "title": "Unable to load payments",
        "description": "Please try again. If the issue continues, please contact Client Services."
      }
    }
  }
}
